import React from 'react';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import QuantityRpCheckboxes from './QuantityRPCheckboxes';
import { sizes } from 'src/styles/Media.styled';
import { isMobileView } from 'src/utils/util';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { displayCheckbox } from 'src/pages/reportUsage/utils/eventHandlerUtil';

const QuantityRPInputBoxes = ({
    item,
    index,
    lotItem,
    lotItemIdx,
    lotSerialValueEntered,
    showTopLabel,
    isChildItem,
    mbLabelLineHeight,
}) => {
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    return (
        <>
            {(item.salesOrg !== 'S030' ||
                item.salesOrg === '' ||
                !item.salesOrg) &&
            !displayCheckbox(item) ? (
                <>
                    <Div>
                        {isMobileView() || winWidth <= sizes.smalDevice ? (
                            <QuantityHeaderContainer
                                mbLineHeight={mbLabelLineHeight}
                            >
                                {t('reportUsage.itemList.used')}
                            </QuantityHeaderContainer>
                        ) : (
                            <QuantityHeaderContainer>
                                {t(
                                    'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                )}
                            </QuantityHeaderContainer>
                        )}

                        <TextWithInputs
                            name={'usedQuantity'}
                            placeholder={t(
                                'reportUsage.replen.replenListView.qty'
                            )}
                            onkeyUp={(e) =>
                                lotSerialValueEntered(
                                    e,
                                    item,
                                    index,
                                    lotItem,
                                    lotItemIdx
                                )
                            }
                            value={item?.usedQuantity}
                            maxLength={2}
                            inputHeight={isMobileView() ? '42px' : '40px'}
                            inputWidth={'48px'}
                            alignText={'center'}
                            topLabel={
                                showTopLabel && t('reportUsage.itemList.used')
                            }
                            inputBorder={
                                item.isInvalidQtyMsg?.length > 0 &&
                                '2px solid #FACFD6'
                            }
                        />
                    </Div>
                </>
            ) : (
                <>
                    <QuantityRpCheckboxes
                        item={item}
                        index={index}
                        lotItem={lotItem}
                        lotItemIdx={lotItemIdx}
                        lotSerialValueEntered={lotSerialValueEntered}
                        showTopLabel
                        isChildItem={isChildItem}
                    />
                </>
            )}
        </>
    );
};

export default QuantityRPInputBoxes;

export const Div = styled.div``;

export const QuantityHeaderContainer = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    text-align: left;
    color: #3c3c3c;
    margin-bottom: -1px;
    ${media.mobileDevice`
        font-size: 12px;
        text-align: center; 
        margin-bottom: ${({ marginBottom }) => marginBottom};
        line-height: ${({ mbLineHeight }) => mbLineHeight};
    `};
`;
